import { urlSource } from "../../utils/utils";
import {
  ClassLevels,
  ClassNight,
  ClassNightWithLocation,
  Freestyles,
} from "../../types";
import "./style.scss";
import { renderPlaylistEmbed } from "../../components/playlists";

interface ConcreteClassNight extends ClassNightWithLocation {
  timestamp: number;
}

export default function renderClassNights(
  classNights: ClassNightWithLocation[],
  with_embeds = false
) {
  const now = Date.now();

  const teaching = classNights
    .map((entry) => {
      return {
        ...entry,
        timestamp: entry["date"]["seconds"] * 1000,
      } as ConcreteClassNight;
    })
    .filter(
      (entry) =>
        !!entry[
          entry["timestamp"] > now ? "teachingBeginner" : "taughtBeginner"
        ]
    );

  const multipleLocations =
    new Set(teaching.map((night) => night["location"].id)).size > 1;

  const renderNight = (entry: ConcreteClassNight) => {
    const variationsVideo = () => {
      if (!entry["variationsVideo"]) {
        return;
      }
      const source = urlSource(entry["variationsVideo"]);
      const _aspectRatio = (url: string) => {
        const decoded = decodeURIComponent(url);
        if (decoded.includes("/reel/")) {
          // e.g. https://www.facebook.com/reel/1368501113804039
          return "9/16";
        }
        // e.g. https://fb.watch/nKO7O_jXtu/
        return "560/314";
        // any other videos in the future
      };
      const _embed = () => {
        if (!entry["variationsVideo"]) {
          return;
        }
        const embedSrc = entry["variationsVideo"];
        const src =
          "https://www.facebook.com/plugins/video.php?show_text=false&href=" +
          embedSrc;
        const styleSet = {
          border: "none",
          overflow: "hidden",
          margin: "0.25em 0",
          maxHeight: "80vh",
          aspectRatio: _aspectRatio(entry["variationsVideo"]),
        };
        return (
          <iframe
            loading="lazy"
            src={src}
            width="100%"
            style={styleSet}
            scrolling="no"
            frameBorder="0"
            allowFullScreen={true}
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          ></iframe>
        );
      };
      return (
        <div class="pt">
          <div>
            <a href={entry["variationsVideo"]}>Video of variations</a>
            {source && !with_embeds && " (" + source + " link)"}
          </div>
          {with_embeds && _embed()}
        </div>
      );
    };
    const renderHeader = () => {
      const date = new Date(entry["timestamp"]).toLocaleDateString("en-AU");
      return (
        <h3>
          {future ? "Teachers" : "Moves"} for {date}
          {multipleLocations && " at " + entry["location"].name}:
        </h3>
      );
    };
    const future = entry["timestamp"] > now;

    const levelsBlock = (section: "teaching" | "taught") => {
      const elems = ClassLevels.map((level) => {
        const key = (section + level) as keyof ClassNight;
        return (
          entry[key] && (
            <div class="pt">
              <strong>{level}</strong>: {entry[key]}
            </div>
          )
        );
      });
      if (elems) {
        return <div>{elems}</div>;
      }
      return;
    };

    const playlists = () => {
      const elems = Freestyles.map((level) => {
        const key = (level.toLowerCase() + "Playlist") as keyof ClassNight;
        const name = level + " Playlist";
        return (
          entry[key] && (
            <div class="pt">
              {renderPlaylistEmbed(name, entry[key] as string)}
            </div>
          )
        );
      });
      if (elems) {
        return <div>{elems}</div>;
      }
      return;
    };

    return (
      <div class="classNight">
        {renderHeader()}
        {levelsBlock(future ? "teaching" : "taught")}
        {variationsVideo()}
        {future ? "" : playlists()}
      </div>
    );
  };

  return <div>{teaching.map(renderNight)}</div>;
}
